<template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
         <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/adm_empresa/usuarios">Usuários</router-link>
          </li>
          <li class="breadcrumb-item active">Detalhes do Usuário</li>
        </ol>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações do Usuário
            </h2>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Nome</label>
                <input
                  readonly
                  type="text"
                  class="form-control"
                  v-model="usuario.name"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>E-Mail</label>
                <input
                  readonly
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="usuario.email"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Telefone</label>
                <input
                  readonly
                  type="text"
                  class="form-control"
                  v-mask="maskTel()"
                  v-model="usuario.telefone"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Usuário Principal</label>
                <input
                  readonly
                  type="text"
                  class="form-control"
                  v-model="usuario.master"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { tratamento_requisicao } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from 'axios'

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      id_usuario: this.$route.params.id_user,
      usuario: [],
			isLoading: false,
    };
  },
  mounted() {
    let self = this;
    self.isLoading = true;
      axios.get(`users/${self.id_usuario}`)
        .then((userRes) => {
          self.usuario = userRes.data;
          self.usuario.confirmaPassword = self.usuario.password;
          self.isLoading = false;

        }, err => {
          self.isLoading = false;
          tratamento_requisicao(err);
        })
  },
  methods: {
    maskTel() {
      let self = this;
      if(self.usuario.telefone)
        return self.usuario.telefone.length == 15 || !self.usuario.telefone.includes('-') ? '(##) #####-####' : '(##) ####-####'
    }
  }
};
</script>

<style>

.img {
  display: flex;
  align-items: center;
}

</style>
